<template>
  <tr
    style="cursor: pointer"
    @click="
      showDetail = true
      onShowDetail()
    "
  >
    <td class="text-no-wrap">
      <v-dialog v-model="showDetail" width="800">
        <v-card>
          <customer-detail v-model="user">
            <div slot="header" class="text-xs-right">
              <v-btn flat fab small class="extra-small" @click="showDetail = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </customer-detail>

          <v-card-text class="text-xs-center">
            <v-btn outline color="grey" @click="showDetail = false">{{ $t('cancel') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-avatar size="30" class="mr-2">
        <img
          v-if="item.profile_pic"
          :src="item.profile_pic"
          width="30"
          height="30"
          :alt="item.first_name + ' ' + item.last_name"
          @error="onFailLoad"
        />
        <img
          v-else
          :src="'/static/img/assets/livechat/profile.png'"
          width="30"
          height="30"
          :alt="item.first_name + ' ' + item.last_name"
        />
      </v-avatar>
      {{ item.first_name }} {{ item.last_name }}
    </td>
    <td class="text-xs-center">
      <span v-if="item.app == 'facebook'" style="color: #3b5998">
        <em class="fab fa-facebook-square" />
      </span>
      <span v-else-if="item.app == 'line'" style="color: #00c300">
        <em class="fab fa-line" />
      </span>
    </td>
    <td>{{ item.subject ? item.subject : '-' }}</td>
    <td>
      <template v-if="item.tags">
        <v-chip
          v-for="tag in item.tags.split(',')"
          :key="tag"
          color="primary"
          text-color="white"
          disabled
          small
          >{{ tag }}</v-chip
        >
      </template>
    </td>
    <td class="text-xs-center">{{ item.starttime | DateFormat('DD/MM/YYYY HH:mm') }}</td>
    <td class="text-xs-center">{{ customerWaitingTime }}</td>
    <td class="text-no-wrap">
      <template v-if="item.assign_by_first_name">
        <v-avatar size="30" class="mr-2">
          <img :src="item.assign_by_profile_pic" width="30" height="30" />
        </v-avatar>
        {{ item.assign_by_first_name }}
      </template>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import CustomerDetail from '@/components/view/dashboard/customer/CustomerDetail.vue'
export default {
  components: {
    CustomerDetail
  },
  props: ['item'],
  data: function () {
    return {
      showDetail: false,
      user: null,
      loading: true,
      showAllIntent: false,
      isEditTag: false,
      usertag: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    customerWaitingTime: function () {
      var vm = this

      var updatetime = moment(vm.item.updatetime)
      var now = moment()

      if (vm.item.adminupdatetime != null) {
        var adminupdatetime = moment(vm.item.adminupdatetime)

        if (adminupdatetime.diff(updatetime) >= 0) {
          return 'รอลูกค้าตอบกลับ'
        }
      }
      return vm.getTimeFormat(now, updatetime)
    },
    filterIntent: function () {
      var vm = this
      return vm.user.intentlist.sort(function (a, b) {
        if (parseInt(a[1]) > parseInt(b[1])) {
          return -1
        }

        if (parseInt(a[1]) < parseInt(b[1])) {
          return 1
        }

        return 0
      })
    },
    userLocale: function () {
      var vm = this
      return config.locale.find(function (locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function () {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function (tag) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    }
  },
  methods: {
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    saveEditTag: function () {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.user.id,
        tags: vm.user.tags || ''
      }
      api.saveUserTags(data, function (error) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function () {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      // if (obj.tag.text.length > 25) {
      //   this.errorTag.push('overmaxlength')
      //   obj.error()
      // } else
      if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error('duplicate')
      } else obj.addTag()
    },
    onEditStatus: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value || ''
      }
      api.saveUserStatus(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value || ''
      }
      api.saveUserEmail(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value || ''
      }
      api.saveUserPhoneno(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onShowDetail: function () {
      var vm = this
      vm.loading = true
      vm.getUsersdata().then(
        (customer) => {
          if (customer.length > 0) {
            vm.user = customer[0]
          }
          vm.loading = false
        },
        (error) => {
          console.error(error)
          vm.loading = false
        }
      )
    },
    getUsersdata: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getUsersdata(
          { userid: vm.item.id, pageid: vm.selectedBot.pageid },
          function (error, response) {
            if (error) {
              reject(error)
            }
            if (response.data) {
              resolve(response.data)
            }
          }
        )
      })
    },
    getTimeFormat: function (date1, date2) {
      if (date1.diff(date2, 'days') > 0) {
        return date1.diff(date2, 'days') + ' วัน'
      } else if (date1.diff(date2, 'hours') > 0) {
        return date1.diff(date2, 'hours') + ' ชม'
      } else if (date1.diff(date2, 'minutes') > 0) {
        return date1.diff(date2, 'minutes') + ' นาที'
      } else if (date1.diff(date2, 'seconds') > 0) {
        return date1.diff(date2, 'seconds') + ' วินาที'
      }
    },
    onFailLoad: function () {
      this.$set(this.item, 'profile_pic', '/static/img/assets/livechat/profile.png')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/qualityexpress/Customer.vue